import { render, staticRenderFns } from "./ExternalLinkWarningModal.vue?vue&type=template&id=d9918b6a"
import script from "./ExternalLinkWarningModal.vue?vue&type=script&lang=ts"
export * from "./ExternalLinkWarningModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports